import { type MutationOptions, useMutation } from 'react-query'

import agent from 'agent'
import useAuth from 'hooks/use-auth'
import { integrationClientsMutationKeys } from 'queries/integration-clients/query-keys'
import { getEndpointWithParams } from 'queries/queries-utils'

function activateIntegrationClient([endpoint, params]: ReturnType<
  typeof integrationClientsMutationKeys.putIntegrationClientByIdentifierActivate
>) {
  return async () => {
    const endpointWithParams = getEndpointWithParams(endpoint, params)

    await agent.put(endpointWithParams)
  }
}

export const usePutIntegrationClientsActivate = (
  identifier: string,
  options?: Omit<MutationOptions, 'mutationKey' | 'mutationFn'>
) => {
  const { currentTeamId: teamId } = useAuth()

  const queryParams = {
    identifier,
    teamId
  }

  const mutationKey =
    integrationClientsMutationKeys.putIntegrationClientByIdentifierActivate(
      queryParams
    )

  return useMutation({
    ...options,
    mutationKey,
    mutationFn: activateIntegrationClient(mutationKey)
  })
}
